module.exports = __webpack_public_path__ + "img/sybs.53835e27.png";